import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import JwtService from "@/common/jwt.service";
import { API_URL } from "@/common/config";

const ApiService = {
  init() {
    Vue.use(VueAxios, axios);
    Vue.axios.defaults.baseURL = API_URL;
  },

  setHeader() {
    Vue.axios.defaults.headers.common[
      "Authorization"
    ] = `Token ${JwtService.getToken()}`;
  },

  query(resource, params) {
    return Vue.axios.get(resource, params).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  get(resource, slug = "") {
    return Vue.axios.get(`${resource}/${slug}`).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  },

  post(resource, params) {
    return Vue.axios.post(`${resource}`, params);
  },

  update(resource, slug, params) {
    return Vue.axios.put(`${resource}/${slug}`, params);
  },

  put(resource, params) {
    return Vue.axios.put(`${resource}`, params);
  },

  delete(resource) {
    return Vue.axios.delete(resource).catch(error => {
      throw new Error(`[RWV] ApiService ${error}`);
    });
  }
};

export default ApiService;

export const CategorysService = {
  getAll(params) {
    return ApiService.query(
      "api/services/app/ProductCategory/GetParent" + (params ? "?" + params : "")
    );
  }
};

export const ProductsService = {
  getAll(params) {
    return ApiService.query(
      "api/services/app/Product/GetAll" + (params ? "?" + params : "")
    );
  },
  search(keyword, params) {
    return ApiService.query(
      `api/services/app/Product/Search?keyword=${keyword}`
    );
  },
  getByCategory(slug, params) {
    return ApiService.query(
      `api/app/category/${slug}/products` + (params ? "?" + params : "")
    );
  },
  getNews(params) {
    return ApiService.query(
      "api/services/app/Product/GetNews" + (params ? "?" + params : "")
    );
  },
  getHots(params) {
    return ApiService.query(
      "api/services/app/Product/GetProductForHome" + (params ? "?" + params : "")
    );
  },
  getBySlug(slug) {
    return ApiService.query(
      `api/services/app/Product/GetBySlug` + `?slug=${slug}`
    );
  }
};
export const NewsService = {
  getAll(params) {
    return ApiService.query(
      "api/services/app/News/GetAll" + (params ? "?" + params : "")
    );
  },
  get(slug) {
    return ApiService.query(
      "api/services/app/News/GetBySlug" + `?slug=${slug}`
    );
  },
  getRelates(newsId) {
    return ApiService.query(
      "api/services/app/News/GetRelates" + `?id=${newsId}`
    );
  },
  getByCategory(slug) {
    return ApiService.query(
      "api/services/app/News/GetByCategory" + `?slug=${slug}`
    );
  }
};

export const PagesService = {
  get(slug) {
    return ApiService.query(
      "api/services/app/Page/GetBySlug" + `?slug=${slug}`
    );
  }
};
